import React, { useEffect } from 'react';
import { motion, useMotionTemplate, useMotionValue } from 'framer-motion';
import '../styles/Background.scss';

const Background = () => {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  useEffect(() => {
    const handleMouseMove = ({ clientX, clientY }) => {
      mouseX.set(clientX);
      mouseY.set(clientY);
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [mouseX, mouseY]);

  return (
    <div className="site-background">
      <div className="site-background__gradient" />
      <div className="site-background__grid" />
      <div className="site-background__noise" />
      <motion.div
        className="site-background__glow"
        style={{
          background: useMotionTemplate`
            radial-gradient(
              600px circle at ${mouseX}px ${mouseY}px,
              rgba(99, 102, 241, 0.08),
              transparent 80%
            )
          `,
        }}
      />
      <div className="site-background__orb site-background__orb--1" />
      <div className="site-background__orb site-background__orb--2" />
      <div className="site-background__orb site-background__orb--3" />
      <div className="site-background__fade-top" />
    </div>
  );
};

export default Background;
